import ReactDOM from 'react-dom';
import { loadDOMComponent } from '../../../../helpers';
import TextField from './TextField';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import { Provider } from 'react-redux';
import { parseRequired } from '../../../../Utils/form.util';

loadDOMComponent({
	selector: 'react-text-field',
	callback: ({ container, context }) => {
		const name = container.getAttribute('name');
		const placeholder = container.getAttribute('placeholder');
		const value = container.getAttribute('value');
		const netteRules = container.getAttribute('data-nette-rules');
		const required = parseRequired(container.getAttribute('required'));

		const handleChange = function (tempValue) {};

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<TextField
						onChange={handleChange}
						type='text'
						name={name}
						placeholder={placeholder}
						value={value}
						required={required}
						data-nette-rules={netteRules}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
